export const initialState = {
    notification: {}
};

export const actions = {
    SET_NOTIFICATION: 'SET_NOTIFICATION'
};